export default __webpack_public_path__ + "7df7b1a5a4ed3d87a5843fef7ece3b1e.ico";